import { formatCurrency } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'currencyCustom',
    standalone: true
})
export class CurrencyCustomPipe implements PipeTransform {
    transform(value: number | string): string | null {
        const valueAsNumber = typeof value === 'string' ? parseFloat(value) : value;
        const isInteger = Number.isInteger(valueAsNumber);
        const format = isInteger ? '0.0' : '0.2';
        return formatCurrency(valueAsNumber, 'en', '$', 'USD', format);
    }
}
